var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic32/global"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16 7C18.2512 9.46452 19.5305 12.6628 19.6 16C19.5305 19.3372 18.2512 22.5355 16 25M16 7C13.7488 9.46452 12.4695 12.6628 12.4 16C12.4695 19.3372 13.7488 22.5355 16 25M16 7C11.0294 7 7 11.0294 7 16C7 20.9706 11.0294 25 16 25M16 7C20.9706 7 25 11.0294 25 16C25 20.9706 20.9706 25 16 25M7.45002 13.3H24.55M7.45 18.7H24.55",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.c6852a731e0b8dbb67228a7a9c03cb1c.svg";
export { ForwardRef as ReactComponent };